<div class="b2a-snackbar__align-container {{snackbarDisplayState}}">
  <div class="b2a-snackbar__container">
    <div class="b2a-snackbar__content" [ngStyle]="{'background-color': snackbarOptions.color}">
      <div class="b2a-snackbar__icon b2a-icon__{{snackbarOptions.icon}}Contour"></div>
      <div class="b2a-snackbar__message">
        {{snackbarOptions.message}}
      </div>
      <div (click)="dismiss()"
           class="b2a-snackbar__close b2a-icon__close"></div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/snackbar/snackbar.component.html